// Store the original parents of the elements
const originalParents = new Map();

function moveElementsForLargeScreens() {
  const elements = document.querySelectorAll('.product__description .ebin');
  
  // when the template changes, the ID also changes... so try to keep the template as it is - just make backups
  // Please update it if there is a better solution
  
 // const aPlusSection = document.querySelector('#shopify-section-template--17659324203239__custom_liquid_jHTABz .container');
  const aPlusSection = document.querySelector('div[id^="shopify-section-template--"][id*="custom_liquid"] .container--large');
  
  elements.forEach(element => {
    // Store the original parent if not already stored
    if (!originalParents.has(element)) {
      originalParents.set(element, element.parentNode);
    }
    aPlusSection.appendChild(element);
  });
}

function restoreElementsToOriginalParents() {
  originalParents.forEach((parent, element) => {
    parent.appendChild(element);
  });
}

function checkScreenSizeAndExecute() {
  if (window.innerWidth > 749) {
    moveElementsForLargeScreens();
  } else {
    restoreElementsToOriginalParents();
  }
}

window.addEventListener('load', checkScreenSizeAndExecute);
window.addEventListener('resize', checkScreenSizeAndExecute);
